<script setup>
import { __, __x } from 'JIX/gettext.js';
const { sitename, site } = window.Stash.common;

defineProps({
    cvUrl: {
        type: String,
        required: true,
    },
});

</script>

<template>
    <div class="jobsearch-cv-banner">
        <h2 class="jobsearch-cv-banner__header">
            {{ __x('Har du et {sitename} CV?', { sitename }) }}
        </h2>
        <p>{{ __x("{sitename} matcher CV'er med virksomhedernes ledige stillinger.", { sitename}) }}</p>
        <a :href="cvUrl" class="btn btn-primary jobsearch-cv-banner__btn">
            {{ __("Opret CV") }}
        </a>
        <img
            :src="`/img/jobindex20/jobsearch/cv-banner--${site}.svg`"
            alt=""
            height="191"
            width="203"
            class="jobsearch-cv-banner__img"
        >
    </div>
</template>